import React from 'react';
import { DocumentIcon } from '../components/icons/legal/DocumentIcon';
import { ShieldIcon } from '../components/icons/legal/ShieldIcon';
import { LockIcon } from '../components/icons/legal/LockIcon';
import { CookieIcon } from '../components/icons/legal/CookieIcon';
import { UsersIcon } from '../components/icons/legal/UsersIcon';

export type LegalAudience = 'clients' | 'candidates' | 'partners';

export interface LegalDoc {
  id: string;
  audience: LegalAudience;
  title: string;
  description?: string;
  updatedAt?: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
}

export const legalDocs: LegalDoc[] = [
  // Pour les clients
  {
    id: 'terms',
    audience: 'clients',
    title: 'Conditions générales (SaaS)',
    description: "Conditions d'utilisation de notre plateforme",
    updatedAt: '5 janvier 2026',
    href: '/legal/terms',
    icon: DocumentIcon,
  },
  {
    id: 'dpa',
    audience: 'clients',
    title: 'Accord de traitement des données (DPA)',
    description: 'Notre engagement sur le traitement de vos données',
    updatedAt: 'À venir',
    href: '/legal/dpa',
    icon: ShieldIcon,
  },
  {
    id: 'privacy',
    audience: 'clients',
    title: 'Politique de confidentialité',
    description: 'Comment nous protégeons vos informations',
    updatedAt: '5 janvier 2026',
    href: '/legal/privacy',
    icon: LockIcon,
  },

  // Pour les candidats
  {
    id: 'candidates-privacy',
    audience: 'candidates',
    title: 'Avis de confidentialité candidats',
    description: 'Protection des données personnelles des candidats',
    updatedAt: 'À venir',
    href: '/legal/candidates-privacy',
    icon: UsersIcon,
  },
  {
    id: 'cookies',
    audience: 'candidates',
    title: 'Politique cookies',
    description: 'Utilisation des cookies et technologies similaires',
    updatedAt: 'À venir',
    href: '/legal/cookies',
    icon: CookieIcon,
  },
];

// Regrouper par audience
export const legalDocsByAudience = {
  clients: legalDocs.filter((doc) => doc.audience === 'clients'),
  candidates: legalDocs.filter((doc) => doc.audience === 'candidates'),
  partners: legalDocs.filter((doc) => doc.audience === 'partners'),
};

// Helper pour trouver un doc par ID
export const findLegalDoc = (id: string): LegalDoc | undefined => {
  return legalDocs.find((doc) => doc.id === id);
};
